import React from 'react';
import { Box, Skeleton } from '@mui/material';

/** Esqueleto das listagens: bloco de filtros + linhas de itens. */
export default function ListSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <Box aria-busy="true" aria-label="Carregando">
      <Skeleton variant="rounded" animation="wave" height={104} sx={{ mb: 3, borderRadius: 3 }} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {Array.from({ length: rows }).map((_, index) => (
          <Skeleton key={index} variant="rounded" animation="wave" height={72} sx={{ borderRadius: 3 }} />
        ))}
      </Box>
    </Box>
  );
}
